import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from './Icon';
import { colorWhite } from '../theme/palette';

const BottomStatusFilter = ({
  options = [],
  value = '',
  onChange,
  countLabel = 'Quantidade'
}) => {
  const parseValue = currentValue => {
    if (!currentValue) {
      return {
        key: ''
      };
    }

    const [key] = currentValue.split(':');
    return {
      key: key || ''
    };
  };

  const handleClick = optionValue => {
    if (!onChange) {
      return;
    }

    const {
      key
    } = parseValue(value);

    if (key !== optionValue) {
      onChange(optionValue);
      return;
    }

    onChange('');
  };

  const { key: activeKey } = parseValue(value);

  return <BottomStatusContainer>
      {options.map(option => {
    const isActive = option.value === activeKey;
      const countText = typeof option.count === 'number' ? String(option.count) : '';
      const amountText = typeof option.amount === 'string' ? option.amount : '';
      const summaryLines = Array.isArray(option.summaryLines) ? option.summaryLines.filter(Boolean) : [];
      const obsText = typeof option.obs === 'string' ? option.obs.trim() : '';
      const isDevolucao = option.value === 'devolucao';
      const showPending = !(isActive && isDevolucao);
      const labelText = isActive && isDevolucao ? 'FINALIZADOS' : option.label;
      return <BottomStatusButton key={option.value} type="button" onClick={() => handleClick(option.value)} data-active={isActive} title={option.label} aria-pressed={isActive}>
            {option.icon && <Icon name={option.icon} size={38} />}
            <BottomStatusText>
              <BottomStatusLabel>{labelText}</BottomStatusLabel>
              {showPending && obsText && <BottomStatusObs>{obsText}</BottomStatusObs>}
              {showPending && summaryLines.length > 0 && summaryLines.map(line => (
                <BottomStatusDirection key={line}>{line}</BottomStatusDirection>
              ))}
              {showPending && summaryLines.length === 0 && <BottomStatusDirection>{countLabel}: {countText}</BottomStatusDirection>}
              {showPending && amountText && <BottomStatusDirection>Valor: {amountText}</BottomStatusDirection>}
            </BottomStatusText>
          </BottomStatusButton>;
    })}
    </BottomStatusContainer>;
};

BottomStatusFilter.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
    count: PropTypes.number,
    amount: PropTypes.string,
    obs: PropTypes.string,
    summaryLines: PropTypes.arrayOf(PropTypes.string)
  })),
  value: PropTypes.string,
  onChange: PropTypes.func,
  countLabel: PropTypes.string
};

const BottomStatusContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: 576px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
`;

const BottomStatusButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-height: 64px;
  padding: 12px 18px;
  border: 1px solid #2456a2;
  background-color: #2456a2;
  color: ${colorWhite};
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;

  svg {
    fill: ${colorWhite};
  }

  &[data-active="true"] {
    background-color: #db181f;
    border-color: #db181f8e;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);
  }

/*   &:hover {
    background-color: #0f9b90;
    border-color: #0b857c;
  } */

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(20, 167, 156, 0.25);
  }

  @media (max-width: 576px) {
    min-height: 32px;
    padding: 4px 6px;
    gap: 4px;
    width: 100%;
    justify-content: flex-start;

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

const BottomStatusText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
`;

const BottomStatusLabel = styled.span`
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1.1;

  @media (max-width: 576px) {
    font-size: 11px;
    letter-spacing: 0;
  }
`;

const BottomStatusDirection = styled.span`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.2px;
  line-height: 1.1;

  @media (max-width: 576px) {
    font-size: 8px;
    letter-spacing: 0;
  }
`;

const BottomStatusObs = styled.span`
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 1.15;
  opacity: 0.92;

  @media (max-width: 576px) {
    font-size: 7px;
    letter-spacing: 0;
  }
`;

export default BottomStatusFilter;
